// import { ReactComponent as StoreVisualizerLogo } from '../../utils/icons/elements-desktop-brand.svg'
import logo from '../../utils/icons/image/essilor-logo.png'

function MapLogo() {
    return (
        <div
            className="rounded-3xl inline-flex bg-white"
            style={{
                width: '220px',
                height: '45px',
                display: 'flex',
                alignItems: 'center',
            }}>
            <img src={logo} alt="logo" />
            {/* <div style={{ width: '50%', textAlign: 'center' }}>Picstore</div> */}
            {/* <StoreVisualizerLogo style={{ width: 185, height: 'auto' }} /> */}
        </div>
    )
}

export default MapLogo

